import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { ResponsivePicture } from "../../../Shared/components/Image";
import { BranchLocalizationLayout } from "../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout";
import { hyphenate } from "../../../Shared/features/hyphenate";
import { isHomeJumbo, renderContents } from "../../custom_components/components/jumbo/jumboUtils";
import { LinkButton } from "../../custom_components/components/library/button";
import { trackJumboButton } from "../../custom_components/components/library/tracking";
const homeJumboVisual = (props, layoutMode)=>/*#__PURE__*/ _jsx(ResponsivePicture, {
        className: `jumbotron__visual jumbotron__visual--${layoutMode}`,
        defaultImageUrl: props.imageUrlFallback,
        cropsPerMedia: [
            {
                crops: [
                    {
                        url: props.imageUrl,
                        width: 440
                    },
                    {
                        url: props.imageUrlLarge,
                        width: 880
                    }
                ]
            }
        ],
        lazyload: false,
        ariaHidden: true,
        height: 440,
        width: 440,
        alt: props.imageAlt
    });
const JumboHeading = (props)=>{
    const { supertitle, title, subtitle } = props;
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            supertitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__supertitle title--md",
                children: supertitle
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "jumbotron__title title--xl",
                children: hyphenate(title)
            }),
            subtitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__subtitle title--md",
                children: subtitle
            })
        ]
    });
};
const homeJumbo = (props)=>/*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--newlarge",
        children: /*#__PURE__*/ _jsx("div", {
            className: "jumbotron__outer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__inner",
                children: [
                    isHomeJumbo(props) && /*#__PURE__*/ _jsx(BranchLocalizationLayout, {
                        ...props.localizationProps
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__top",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "jumbotron__top-inner container--mg align--center",
                                children: /*#__PURE__*/ _jsx(JumboHeading, {
                                    ...props
                                })
                            }),
                            props.imageUrl && homeJumboVisual(props, "mob")
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__bottom",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "jumbotron__bottom-inner container--mg align--center",
                            children: [
                                props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                                    className: "jumbotron__intro",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "text--styled",
                                            children: props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                        }),
                                        props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                            variant: "black",
                                            arrow: false,
                                            route: props.buttonUrl,
                                            handle: ()=>trackJumboButton(props.buttonTitle),
                                            className: "button button--primary button--arrow jumbotron__clickable",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: props.buttonTitle
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                props.imageUrl && homeJumboVisual(props, "desk")
                            ]
                        })
                    })
                ]
            })
        })
    });
export default homeJumbo;
